/**
 * Player avatar — image with initial-letter fallback.
 */

import { cn } from "../../lib/utils";

type PlayerAvatarProps = {
  avatarUrl: string | null;
  username: string;
  size?: "sm" | "md" | "lg";
  ringColor?: string;
  className?: string;
};

const sizeClasses = {
  sm: "w-6 h-6 text-[10px]",
  md: "w-7 h-7 text-xs",
  lg: "w-8 h-8 text-xs",
} as const;

export function PlayerAvatar({
  avatarUrl,
  username,
  size = "md",
  ringColor = "ring-surface-600/40",
  className,
}: PlayerAvatarProps) {
  return (
    <div
      className={cn(
        "shrink-0 rounded-full overflow-hidden ring-2 flex items-center justify-center font-bold",
        sizeClasses[size],
        ringColor,
        !avatarUrl && "bg-surface-700 text-surface-400",
        className,
      )}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="" className="w-full h-full object-cover" />
      ) : (
        (username ?? "?").charAt(0).toUpperCase()
      )}
    </div>
  );
}
